export class ResultadoValidacion{

    constructor() {
        this.Mensaje = "";
        this.Errores = [];
        this.EsValido = false;
    }

    Mensaje: string;
    Errores : any[];
    EsValido : boolean;
}